import React, { useState, useEffect } from 'react';
import { PropTypes } from 'prop-types';
import { Field } from 'redux-form';

// eslint-disable-next-line import/prefer-default-export
export const NamePartsInput = ({ className, disableFields, useFullNameExternal, setUseFullNameExternal, fullNameFieldName,
  firstNameFieldName, lastNameFieldName, middleNameFieldName }) => {
  const [useFullNameInternal, setUseFullNameInternal] = useState(true);
  const useFullName = useFullNameExternal == null ? useFullNameInternal : useFullNameExternal;
  const setUseFullName = setUseFullNameExternal == null ? setUseFullNameInternal : setUseFullNameExternal;

  const onClick = () => {
    setUseFullName(!useFullName);
  };

  useEffect(() => {
    if (disableFields === true) {
      setUseFullName(true);
    }
  }, [disableFields]);

  return (
    <div className={ className }>
      <div id="name-parts-input-button-wrapper">
        <button
          className={ `btn ${ useFullName ? 'btn-primary' : 'btn-secondary' }` }
          onClick={ () => onClick() }
          type="button"
          disabled={ disableFields }
          id="btn-name-parts-input-full"
        >
          Full Name
        </button>
        <button
          className={ `btn ${ useFullName ? 'btn-secondary' : 'btn-primary' }` }
          onClick={ () => onClick() }
          type="button"
          disabled={ disableFields }
          id="btn-name-parts-input-parts"
        >
          Name Parts
        </button>
      </div>
      { useFullName ? (
        <div>
          <Field
            id="fullName"
            name={ fullNameFieldName }
            component="input"
            className="form-input"
            type="text"
            placeholder="Enter shareholder name"
            disabled={ disableFields }
          />
        </div>
      ) : (
        <div>
          <div>
            <Field
              id="firstName"
              name={ firstNameFieldName }
              component="input"
              className="form-input"
              type="text"
              placeholder="First name"
              disabled={ disableFields }
            />
          </div>
          <div>
            <Field
              id="middleName"
              name={ middleNameFieldName }
              component="input"
              className="form-input"
              type="text"
              placeholder="Middle name"
              disabled={ disableFields }
            />
          </div>
          <div>
            <Field
              id="lastName"
              name={ lastNameFieldName }
              component="input"
              className="form-input"
              type="text"
              placeholder="Last name"
              disabled={ disableFields }
            />
          </div>
        </div>
      )}
    </div>
  );
};

NamePartsInput.propTypes = {
  className: PropTypes.string,
  disableFields: PropTypes.bool,
  useFullNameExternal: PropTypes.bool,
  setUseFullNameExternal: PropTypes.func,
  fullNameFieldName: PropTypes.string,
  firstNameFieldName: PropTypes.string,
  middleNameFieldName: PropTypes.string,
  lastNameFieldName: PropTypes.string

};

NamePartsInput.defaultProps = {
  className: '',
  disableFields: false,
  useFullNameExternal: null,
  setUseFullNameExternal: null,
  fullNameFieldName: 'customerName',
  firstNameFieldName: 'firstName',
  middleNameFieldName: 'middleName',
  lastNameFieldName: 'lastName'
};
